<template>
  <RouterView :key="$route.fullPath" />
</template>

<script>
import { LOAD_GPS_WITH_DEVICE_ID } from './gpsDeviceStore'

export default {
  name: 'GPSDeviceModule',

  props: {
    gpsDeviceStorePath: {
      type: String,
      required: true
    },

    deviceId: {
      type: String,
      required: true
    }
  },

  created() {
    const loadGPSWithDeviceIdAction = `${this.gpsDeviceStorePath}/${LOAD_GPS_WITH_DEVICE_ID}`
    const deviceId = this.deviceId
    this.$store.dispatch(loadGPSWithDeviceIdAction, { deviceId })
  }
}
</script>

<style></style>
